<template>
  <StreamPlatformForm
    :platform-key="'facebook'"
    :close-modal="closeModal"
    :cast-details="castDetails"
    :step-three-props="stepThreeProps"
    :handle-edit-cast="handleEditCast"
  />
</template>

<script>
import StreamPlatformForm from './StreamPlatformForm.vue';

export default {
  name: 'FacebookStreamModal',
  props: ['closeModal', 'castDetails', 'stepThreeProps', 'handleEditCast'],
  components: { StreamPlatformForm },
};
</script>
